import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form, Spin, Select, Tabs, Space, DatePicker } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message';
import SelectProgrammeModal from './selectProgrammeModal';
import './programme.css';

const { Option } = Select;
const { TabPane } = Tabs;

const Programme = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const activeInd = Form.useWatch('activeInd', form);
    const [tabIndex, setTabIndex] = useState("1");
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [programmeModel, setProgrammeModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [deptList, setDeptList] = useState([]);
    const [isProgrammeModal, setIsProgrammeModal] = useState(false);
    const [programmeTable, setProgrammeTable] = useState([]);
    const [isProgrammeDeleteModal, setIsProgrammeDeleteModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState('');
    const tableColumns = {
        progCode: "prog_code",
        progTitle: "prog_title",
    }
    const disabledDate = current => {
        return current && current > moment().endOf('day');
    };

    useEffect(() => {
        searchAllDept();
        search(pageSize, 1, "N");
    }, []);

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
    }

    //查询
    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("commonDropDown/searchAllDept").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("programme/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    //添加
    const add = () => {
        messageShowHandler();//清空提示信息
        initForm({ activeInd: 'Y' });
        setFlag("add");
        setTabIndex("2");
        setProgrammeModel({})
        setProgrammeTable([])
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            progCode: model.progCode ?? '',
            progTitle: model.progTitle ?? '',
            progTitleTC: model.progTitleTC ?? '',
            progTitleC: model.progTitleC ?? '',
            activeInd: model.activeInd ?? '',
            inactiveDate: (model.inactiveDate && moment(model.inactiveDate)) ?? null,
            progLaunchYear: (model.progLaunchYear && moment(model.progLaunchYear, Config.dateFormat7)) ?? '',
            deptId: model.deptId ?? '',
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setProgrammeModel(model)
        setIsDeleteFrame(true);
        setDeleteTipText("Programme Code" + ":" + model.progCode + "")
    }

    //删除
    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let model = programmeModel;
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("programme/delete", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    const onSave = (model) => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {
            url = "programme/insert";
        } else if (flag === "edit") {
            url = "programme/update";
            model.progId = programmeModel.progId;
            model.lastUpdatedDate = programmeModel.lastUpdatedDate;
        }
        model.progLaunchYear = model.progLaunchYear ? moment(model.progLaunchYear).format(Config.dateFormat7) : null
        if (model.activeInd === 'Y') {
            model.inactiveDate = null
        }
        if (programmeTable) {
            model.programmeModelList = programmeTable;
        }
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" == data.msg) {
                searchById(data.object)
                setFlag("edit");
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    //取消 
    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const update = (model, e) => {
        e.stopPropagation();
        searchById(model.progId)
        setFlag("edit");
        setTabIndex("2");
    }

    const view = (model, e) => {
        e.stopPropagation();
        searchById(model.progId)
        setFlag("view");
        setTabIndex("2");
    }

    const searchById = (progId) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("programme/searchById", progId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                let programmeModelList = data.object.programmeModelList ?? [];
                setProgrammeTable(programmeModelList);
                initForm(model)
                setProgrammeModel(model)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const closeProgrammeModal = (flag, list) => {
        if (flag) {
            let mergedArray = programmeTable.concat(list);
            let uniqueArray = mergedArray.reduce((acc, obj) => {
                let existingObj = acc.find(item => item.progId === obj.progId);
                if (!existingObj) {
                    acc.push(obj);
                }
                return acc;
            }, []);
            setProgrammeTable(uniqueArray)
        }
        setIsProgrammeModal(false);
    }

    const programmeDeleteClose = (state) => {
        if (state) {
            setProgrammeTable(list => {
                list.splice(deleteIndex, 1);
                return [...list];
            });
        }
        setIsProgrammeDeleteModal(false);
    }

    const progDelete = (index, e, model) => {
        e.stopPropagation();
        setDeleteIndex(index);
        setDeleteTipText("Programme Code" + ":" + model.progCode)
        setIsProgrammeDeleteModal(true);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: trans.progCode[Config.backLang],
            dataIndex: 'progCode',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progCode') },
        },
        {
            title: trans.progTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: 'tableWidth20',
        },
        {
            title: trans.progLaunchYear[Config.backLang],
            dataIndex: 'progLaunchYear',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progLaunchYear') },
        },
        {
            title: 'Department',
            dataIndex: 'deptId',
            className: 'tableWidth35',
            render: text => deptList.map(item => item.deptId === text && item.deptCode + '-' + item.deptDisplayName)
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'activeInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed: 'right',
            width: 206,
            className: ' sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysUpdate' onClick={(e) => view(record, e)} hidden={Config.funcInfo.canUpdate === "Y"}><EyeOutlined /> {trans.view[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];
    /*eslint-enable*/

    const columnsTwo = [
        {
            title: trans.progCode[Config.backLang],
            dataIndex: 'progCode',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progCode') },
        },
        {
            title: trans.progTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: 'tableWidth30',
        },
        {
            title: trans.progLaunchYear[Config.backLang],
            dataIndex: 'progLaunchYear',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progLaunchYear') },
        },
        {
            title: 'Department',
            dataIndex: 'deptId',
            className: 'tableWidth35',
            render: text => deptList.map(item => item.deptId === text && item.deptCode + '-' + item.deptDisplayName)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            width: 90,
            className: ' sysControls',
            fixed: 'right',
            render: (text, record, index) => <div className='operation'>
                {flag != 'view' && <div className='sysDelete' onClick={(e) => progDelete(index, e, record)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>}
            </div>
        },
    ]

    return (
        <div id="container" className="template programme">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.admin[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {isProgrammeDeleteModal ? <PopupFrame close={programmeDeleteClose} deleteTipText={deleteTipText} /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.progCode[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.progCode || ''}
                                                placeholder={trans.progCode[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('progCode', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.progTitle[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.progTitle || ''}
                                                placeholder={trans.progTitle[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('progTitle', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.deptCode[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className="sysSelect" placeholder={trans.deptCode[Config.backLang]}
                                                value={searchModel.deptId || ''}
                                                onChange={(e) => searchChange('deptId', e)}
                                            >
                                                <Option value=""></Option>
                                                {deptList.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + '-' + item.deptDisplayName}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button className="sysBtn btnBlue" type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1200 }}
                                    rowKey="progId"
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]} forceRender={true}>
                            <Form
                                form={form} onFinish={onSave}
                            >
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParams mustFill">{trans.progCode[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progCode"
                                                rules={[
                                                    { required: true, message: trans.progCodeIsNoNull[Config.backLang] },
                                                ]}
                                                getValueFromEvent={(e) => Base.codeChange(e, 15)}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.progCode[Config.backLang]} maxLength={15}
                                                    disabled={flag === 'edit' || flag === 'view'}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParams mustFill">{trans.deptCode[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="deptId"
                                                rules={[
                                                    { required: true, message: trans.deptCodeIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select placeholder={trans.deptCode[Config.backLang]} className='sysSelect'
                                                    disabled={flag === 'view'}
                                                >
                                                    <Option value=''></Option>
                                                    {deptList.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + '-' + item.deptDisplayName}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParams mustFill">{trans.progTitle[Config.backLang]} </div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="progTitle"
                                                rules={[
                                                    { required: true, message: trans.progTitleIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.progTitle[Config.backLang]}
                                                    maxLength={100}
                                                    disabled={flag === 'view'}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParams mustFill">{trans.progTitleC[Config.backLang]} </div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="progTitleC"
                                                rules={[
                                                    { required: true, message: trans.progTitleCIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.progTitleC[Config.backLang]}
                                                    maxLength={100}
                                                    disabled={flag === 'view'}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParams mustFill">{trans.progTitleTC[Config.backLang]} </div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="progTitleTC"
                                                rules={[
                                                    { required: true, message: trans.progTitleTCIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.progTitleTC[Config.backLang]}
                                                    maxLength={100}
                                                    disabled={flag === 'view'}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParams mustFill">{trans.activeInd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="activeInd"
                                                rules={[
                                                    { required: true, message: trans.activeIndIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select placeholder={trans.activeInd[Config.backLang]} className='sysSelect'
                                                    onChange={(e) => {
                                                        if (e === 'N') {
                                                            form.setFieldValue('inactiveDate', moment())
                                                        } else {
                                                            form.setFieldValue('inactiveDate')
                                                        }
                                                    }}
                                                    disabled={flag === 'view'}
                                                >
                                                    <Option value=''></Option>
                                                    {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {activeInd === 'N' ?
                                        <div className='sysCol'>
                                            <div className="sysParams  mustFill">{trans.inactiveDate[Config.backLang]} </div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                    rules={[
                                                        { required: true, message: 'Inactive Date is required.' },
                                                    ]}
                                                    disabled={flag === 'view'}
                                                >
                                                    <DatePicker placeholder={trans.inactiveDate[Config.backLang]}
                                                        className="parts-numberInput datePickerAllWidth"
                                                        disabledDate={disabledDate}
                                                        format={Config.dateFormat5} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        :
                                        <div className='sysCol'>
                                            <div className="sysParams ">{trans.inactiveDate[Config.backLang]} </div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                >
                                                    <DatePicker placeholder={trans.inactiveDate[Config.backLang]}
                                                        className="parts-numberInput datePickerAllWidth"
                                                        disabled
                                                        format={Config.dateFormat5} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParams ">{trans.progLaunchYear[Config.backLang]} </div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progLaunchYear"
                                            >
                                                <DatePicker placeholder={trans.progLaunchYear[Config.backLang]}
                                                    className="parts-numberInput datePickerAllWidth"
                                                    picker="year"
                                                    format={Config.dateFormat7}
                                                    disabled={flag === 'view'}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysBodyRow">
                                    <div className="userRoleTitleRow">{trans.subProgramme[Config.backLang]}</div>
                                    <div className="sysBodyRow">
                                        {flag != 'view' && <Button className="sysBtnTwo btnBlue" type="primary" hidden={Config.funcInfo.canInsert === "N"} onClick={() => setIsProgrammeModal(true)} icon={<PlusCircleOutlined />} >{trans.add[Config.backLang]}</Button>}
                                    </div>
                                </div>
                                <div className="sysTable" id="tableOne">
                                    <Table
                                        scroll={{ x: 1200 }}
                                        rowKey="progId" //Key值
                                        columns={columnsTwo} //列名
                                        dataSource={programmeTable} //数据
                                        pagination={false}
                                    />
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isProgrammeModal && <SelectProgrammeModal onClose={closeProgrammeModal} checkboxState={programmeTable ?? []} programmeModel={programmeModel} />}
        </div>
    )
}

export default Programme;